import { render, staticRenderFns } from "./SpecialDetails.vue?vue&type=template&id=4ae92dac&scoped=true"
import script from "./SpecialDetails.vue?vue&type=script&lang=js"
export * from "./SpecialDetails.vue?vue&type=script&lang=js"
import style0 from "./SpecialDetails.vue?vue&type=style&index=0&id=4ae92dac&prod&scoped=true&lang=css"
import style1 from "./SpecialDetails.vue?vue&type=style&index=1&id=4ae92dac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae92dac",
  null
  
)

export default component.exports